import styled from 'styled-components';

export const HomePageContainer = styled.div`
    text-align: center;
    padding: 0rem;
`;

export const HeroContainer = styled.div`
    background: linear-gradient(135deg, #0f1724 0%, #1a1a2e 100%);
    padding: 0rem 0rem;
    border-radius: 0.5rem;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('/img/LogoDuoaColor.png');
        background-size: 400px;
        background-repeat: repeat;
        background-position: center;
        opacity: 0.05;
        z-index: 1;
        pointer-events: none;
    }

    h1,
    p,
    .cta-button {
        position: relative;
        z-index: 2;
    }

    h1 {
        color: white;
        margin-bottom: 1rem;
        font-size: 2.5rem;
    }

    p {
        color: #e2e8f0;
        font-size: 1.2rem;
        margin-bottom: 2rem;
    }
`;

export const VisuallyHiddenH1 = styled.h1`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`;

export const CtaButton = styled.a`
    background: linear-gradient(90deg, #ff6b8b, #6b5bff);
    color: white;
    padding: 1rem 2rem;
    text-decoration: none;
    border-radius: 0.5rem;
    font-weight: bold;
    margin-top: 1rem;
    display: inline-block;
    border: none;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(107, 91, 255, 0.4);
    }
`;